function navCarousel() {
  var checkWidth = window.innerWidth;
  var additionalNavWrapper = $("#additional-nav");
  if (checkWidth > 768) {
    if (typeof additionalNavWrapper.data('owl.carousel') != 'undefined') {
      additionalNavWrapper.data('owl.carousel').destroy();
    }
    additionalNavWrapper.removeClass('owl-carousel');
  } else if (checkWidth < 768) {
    additionalNavWrapper.addClass('owl-carousel');
    additionalNavWrapper.owlCarousel({
      loop:true,
        margin:20,
        nav:true,
        center:false,
        responsive:{
            0:{
                items:1
            },
            520:{
                items:2
            },
            768:{
                items:2
            }
        }
    });
  }
}

navCarousel();
$(window).resize(navCarousel);	


var $home = $(".header--home");

if($home) {
    $home.on('click', function (e) {
         $('html,body').delay(0).animate({scrollTop: 0}, animationTime + 25, 'easeInOutExpo');
    });
}